/**
 * Impresión de la factura electrónica de chasis: siempre en hoja grande, sin
 * depender del formato elegido en el POS (que suele ser el ticket de 80 mm).
 * La usan la pantalla de facturación de chasis y la reimpresión de Facturas
 * emitidas.
 */
export const CONFIGURACION_IMPRESION_CHASIS = { plantillaPorDefecto: "carta-profesional" };

/**
 * La pantalla de chasis guarda `tipofactura = "FACTURA ELECTRONICA"`, que la
 * columna (15 caracteres) deja como "FACTURA ELECTRO".
 */
export const esFacturaChasis = (tipofactura) =>
  String(tipofactura || "").trim().toUpperCase().startsWith("FACTURA ELECTRO");

const NOMBRES_ECF = {
  31: "Factura de Crédito Fiscal Electrónica",
  32: "Factura de Consumo Electrónica",
  44: "Comprobante Electrónico para Regímenes Especiales",
  45: "Comprobante Electrónico Gubernamental",
};

/**
 * Título de la hoja según el tipo de e-CF (por el código o el prefijo del
 * e-NCF). "" si no es uno de esos tipos. `tipofactura` ("FACTURA ELECTRO") no
 * sirve de título: la columna lo deja recortado.
 */
export const tituloComprobante = (ncf, codigo) => {
  const cod = String(codigo ?? "").trim() || String(ncf || "").trim().toUpperCase().slice(1, 3);
  return NOMBRES_ECF[cod] || "";
};

/**
 * Monto exento de una factura de chasis reimpresa: subtotal de las líneas sin
 * ITBIS (la placa). En la reimpresión `impuesto` es el monto de ITBIS de la
 * línea (histfact.itbis), no la tasa.
 */
export const montoExentoChasis = (items) =>
  Math.round(
    (items || [])
      .filter((it) => !(Number(it.impuesto) > 0))
      .reduce((s, it) => s + (Number(it.subtotal) || 0), 0) * 100
  ) / 100;
